<template>
    <rounded-container variant="dark">
        <template v-slot:title>
            Latest events 

            <span v-if="numberEventsToday > 0" class="text-secondary">
                <span class="ml-2">{{ sumValueStocks }}</span>
                <span class="ml-2">{{ sumValueCrypto }}</span>
                <span class="ml-2">{{ numberEventsToday }}</span>
            </span>
        </template>

        <b-container>
            <event-list :eventList="events" includeSymbol showAll />
        </b-container>

    </rounded-container>
</template>

<script>

import { mapState } from 'vuex';

import formatter from '@/mixins/formatter';
import eventsMixin from '@/mixins/eventsMixin';

import RoundedContainer from '@/components/style/RoundedContainer.vue';
import EventList from '@/components/EventList.vue';

export default {
    name: 'LastAddedPositions',
    components: {
        RoundedContainer,
        EventList,
    },
    mixins: [formatter, eventsMixin],
    created() {
        this.$store.dispatch("retrieveLastOpenPositions");
    },
    computed: {
        ...mapState({
            events: state => state.events,
        }),
        totals() {
            return this.aggregateEventData(this.events);
        },
        sumValueStocks() {
            return this.totals.stock.sumExits - this.totals.stock.sumBuys;
        },
        sumValueCrypto() {
            return this.totals.crypto.sumExits - this.totals.crypto.sumBuys;
        },
        numberEventsToday() {
            return this.totals.numberEventsToday;
        },
    }
}
</script>
